/**
 * Formatos Flyer V2 — reutiliza dimensiones digitales de Lista Exprés donde aplica.
 */
export const FLYER_FORMATS = [
  { key: 'cuadrado', label: 'WhatsApp / Social 1:1', width: 1080, height: 1080, kind: 'digital' },
  { key: 'historia', label: 'Historia / Estado 9:16', width: 1080, height: 1920, kind: 'digital' },
  { key: 'a4', label: 'Impresión A4', width: 794, height: 1123, kind: 'print' }
];

export function getFlyerFormat(key) {
  return FLYER_FORMATS.find((f) => f.key === key) || FLYER_FORMATS[0];
}
